'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var Text = require('@swiggy-private/dls-web-core/dist/components/Text');
var ThemeProvider = require('@swiggy-private/dls-web-theme/dist/components/ThemeProvider');
var jsUtils = require('@swiggy-private/js-utils');
var React = require('react');
var styled = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const fadeInItem = styled.keyframes `
  0% {
    transform: translateY(16px);
    visibility: hidden;
  }
  1% {
    transform: translateY(16px);
    visibility: visible;
  }

  100% {
    transform: translateY(0);
    visibility: visible;
  }
`;
const fadeInItemAnimation = styled.css(["", " 112ms ease-out forwards;"], fadeInItem);
const clickItem = styled.keyframes `
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.95);
  }

  100% {
    transform: scale(1);
  }
`;
const clickItemAnimation = styled.css(["", " 200ms ease-in-out forwards;"], clickItem);
const fadeOutItem = styled.keyframes `
  0% {
    transform: translateY(0);
    visibility: visible;
  }
  99% {
    transform: translateY(16px);
    visibility: visible;
  }

  100% {
    transform: translateY(16px);
    visibility: hidden;
  }
`;
const fadeOutItemAnimation = styled.css(["", " 100ms ease-in forwards;"], fadeOutItem);
const Container = styled__default['default'].div `
    background: ${({ theme, background = "background_Secondary" }) => theme.colors[theme.colorMode][background]};
    border-radius: ${({ theme }) => theme.cornerRadius.medium};
    padding: ${({ theme }) => theme.spacing.small}
        ${({ theme, hasAssets }) => (hasAssets ? theme.spacing.small : theme.spacing.medium)};
    position: absolute;
    visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
    animation: ${({ visible }) => (visible ? fadeInItemAnimation : fadeOutItemAnimation)};
`;
const ScaleContainer = styled__default['default'].div `
    display: flex;
    align-items: center;
    &:active {
        animation: ${clickItemAnimation};
    }
`;
const LeftIconContainer = styled__default['default'].div(({ theme }) => ({
    marginRight: theme.spacing.small,
}));
const RightIconContainer = styled__default['default'].div(({ theme }) => ({
    marginLeft: theme.spacing.small,
}));

const Toast = ({ altText, message, leftAsset, rightAsset, background, show, autoDismiss, onDismiss = () => { }, onClick, containerClass, }) => {
    const theme = styled.useTheme();
    const [visible, setVisible] = React.useState(show);
    const timer = React.useRef();
    const alt = !jsUtils.isEmpty(altText) ? altText : message;
    const wrapperRef = React.useRef(null);
    function useOutsideAlerter(ref) {
        React.useEffect(() => {
            function handleClickOutside(event) {
                if (ref.current && !ref.current.contains(event.target)) {
                    setVisible(false);
                    onDismiss();
                }
            }
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }
    useOutsideAlerter(wrapperRef);
    React.useEffect(() => {
        setVisible(show);
        if (!show) {
            clearTimeout(timer.current);
        }
    }, [show]);
    React.useEffect(() => {
        if (autoDismiss && show) {
            timer.current = setTimeout(() => {
                setVisible(false);
                onDismiss();
            }, 4000);
        }
        return () => {
            if (timer.current) {
                clearTimeout(timer.current);
            }
        };
    }, [autoDismiss, onDismiss, show]);
    return (React__default['default'].createElement(ThemeProvider.ThemeProvider, { theme: theme, colorMode: "dark" },
        React__default['default'].createElement(Container, { "aria-label": alt, background: background, hasAssets: !jsUtils.isEmpty(leftAsset) || !jsUtils.isEmpty(rightAsset), visible: visible, ref: wrapperRef, onClick: onClick, className: containerClass, "data-testid": "toast-container" },
            React__default['default'].createElement(ScaleContainer, null,
                !jsUtils.isEmpty(leftAsset) && (React__default['default'].createElement(LeftIconContainer, { "aria-hidden": true }, leftAsset)),
                React__default['default'].createElement(Text.Text, { maxLines: 2, variant: "body_B3_Med", color: "text_Highest_Emphasis", "data-testid": "toast-message", "aria-hidden": true }, message),
                !jsUtils.isEmpty(rightAsset) && (React__default['default'].createElement(RightIconContainer, { "aria-hidden": true }, rightAsset))))));
};
var Toast$1 = React__default['default'].memo(Toast);

exports.Toast = Toast$1;
//# sourceMappingURL=index.js.map
